import { isDev } from '../../../core/utils/is-node-environment.js';
import { ChartMessage } from '../types/chart-message.js';

/**
 * Output chart messages, either by using the user provider handler
 * on writing them to the console in development environments
 * @param messages - messages to oupput
 * @param customHandler - additional handler to output messages
 */
export function outputMessages(
  messages: ChartMessage[],
  customHandler: ((messages: ChartMessage[]) => void) | undefined,
): void {
  // TODO: This is slowing rendering down quite significantly for huge datasets
  // can we remove this condition and only provide the messages when a callback is provided?
  // we should also only run the detection of inconsistencies when a callback is provided
  if (isDev()) {
    // eslint-disable-next-line no-console
    messages.forEach(({ message }) => console.warn(message));
  }

  customHandler?.(messages);
}
